var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusRead = function SvgStatusRead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6.5 14H3.333A1.333 1.333 0 0 1 2 12.667V3.333C2 2.597 2.597 2 3.333 2h9.334C13.403 2 14 2.597 14 3.333V8.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.333 7H9L8 9.5 6.333 3.667 5 7H3.667M8.094 12.755c-.049-.077-.073-.116-.086-.175a.4.4 0 0 1 0-.16c.013-.06.037-.098.086-.175C8.494 11.61 9.685 10 11.5 10s3.006 1.609 3.406 2.245c.049.077.073.116.086.175.01.045.01.115 0 .16-.013.06-.037.098-.086.175-.4.636-1.591 2.245-3.406 2.245s-3.006-1.609-3.406-2.245"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M11.5 13.571c.59 0 1.067-.48 1.067-1.071 0-.592-.478-1.071-1.067-1.071-.59 0-1.067.48-1.067 1.071 0 .592.478 1.071 1.067 1.071"
  })));
};
export default SvgStatusRead;